export default "__VITE_ASSET__Brnbeqd6__"